var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column-layout" },
    [
      _c(
        "el-form",
        {
          ref: "adoptedServcInfo",
          attrs: { model: _vm.adoptedServc, rules: _vm.adoptedServcRules }
        },
        [
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("分类信息")]),
            _vm._v(" "),
            _vm.adoptedServc.ssuId == -1 || _vm.adoptedServc.ssuId == null
              ? _c(
                  "a",
                  {
                    staticClass: "swb-btn-link",
                    on: {
                      click: function($event) {
                        _vm.selectCatInfo()
                      }
                    }
                  },
                  [_vm._v("选择")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("分类名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "servcCatName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.adoptedServc.servcCatName,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedServc, "servcCatName", $$v)
                          },
                          expression: "adoptedServc.servcCatName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("品牌名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "servcBrandName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.adoptedServc.servcBrandName,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedServc, "servcBrandName", $$v)
                          },
                          expression: "adoptedServc.servcBrandName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("服务信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: {
                          disabled:
                            _vm.adoptedServc.ssuId != -1 &&
                            _vm.adoptedServc.ssuId != null
                        },
                        model: {
                          value: _vm.adoptedServc.name,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedServc, "name", $$v)
                          },
                          expression: "adoptedServc.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("价格信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("价格")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "price" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: {
                          type: "number",
                          disabled:
                            _vm.adoptedServc.ssuId != -1 &&
                            _vm.adoptedServc.ssuId != null
                        },
                        model: {
                          value: _vm.adoptedServc.price,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedServc, "price", $$v)
                          },
                          expression: "adoptedServc.price"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-tips" }, [_vm._v("元")])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("要求信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("响应时长（分钟）")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "rspTimeMi" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: {
                          disabled:
                            _vm.adoptedServc.ssuId != -1 &&
                            _vm.adoptedServc.ssuId != null
                        },
                        model: {
                          value: _vm.adoptedServc.rspTimeMi,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedServc, "rspTimeMi", $$v)
                          },
                          expression: "adoptedServc.rspTimeMi"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("上门时长（分钟）")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "arriveTimeMi" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: {
                          disabled:
                            _vm.adoptedServc.ssuId != -1 &&
                            _vm.adoptedServc.ssuId != null
                        },
                        model: {
                          value: _vm.adoptedServc.arriveTimeMi,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedServc, "arriveTimeMi", $$v)
                          },
                          expression: "adoptedServc.arriveTimeMi"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("维修时长（分钟）")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "repairedTimeMi" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: {
                          disabled:
                            _vm.adoptedServc.ssuId != -1 &&
                            _vm.adoptedServc.ssuId != null
                        },
                        model: {
                          value: _vm.adoptedServc.repairedTimeMi,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedServc, "repairedTimeMi", $$v)
                          },
                          expression: "adoptedServc.repairedTimeMi"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("其他")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("星级")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "favorLevel" } },
                    [
                      _c("el-rate", {
                        model: {
                          value: _vm.adoptedServc.favorLevel,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedServc, "favorLevel", $$v)
                          },
                          expression: "adoptedServc.favorLevel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("备注")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "desc" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x",
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入备注信息"
                        },
                        model: {
                          value: _vm.adoptedServc.desc,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedServc, "desc", $$v)
                          },
                          expression: "adoptedServc.desc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-548f4e16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-548f4e16","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/AdoptedServcSave.vue
// module id = 3115
// module chunks = 0